import './BuilderView.css';
import ArticleBuilderView from './ArticleBuilder/ArticleBuilderView';
import React from 'react';
import BookBuilderView from './BookBuilder/BookBuilderView';

const BuilderView: React.FC = () => {
  return <BookBuilderView />;
};

export default BuilderView;
